import React from "react";

import { Parallax } from "react-spring";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
// import Button from '@material-ui/core/Button';
// import ReactDOM from 'react-dom'
// import { withStyles } from '@material-ui/core/styles';
// import Animated from 'animated/lib/targets/react-dom'
// import Easing from 'animated/lib/Easing'
// import scanvid from './projects/dfi.gif'
import projects from "./projects/projects.json";
import Typing from "react-typing-animation";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import "./animation.css";

import { Helmet } from "react-helmet";

// Little helpers ...
//const url = (name, wrap = false) => `${wrap ? 'url(' : ''}https://awv3node-homepage.surge.sh/build/assets/${name}.svg${wrap ? ')' : ''}`

const homeT = {
  fontSize: "60px",
  position: "fixed",
  marginLeft: "10%",
  marginTop: "6%",
};
const desc = {
  position: "fixed",
  marginLeft: "10%",
  marginTop: "11%",
};
const pStyle = {
  position: "fixed",
  width: "100%",
  maxWidth: 360,
  marginLeft: "10%",
  marginTop: "13%",
  borderLeftColor: "grey",
  borderLeftStyle: "solid",
  borderLeftWidth: "thin",
  overflow: "auto",
  maxHeight: 200,
  zIndex:'1'
};

const tes = {
  backgroundColor: "aliceblue",
};
const flags = {
  de: "https://cdn.countryflags.com/thumbs/germany/flag-400.png",
  qa: "https://icons.iconarchive.com/icons/custom-icon-design/all-country-flag/64/Qatar-Flag-icon.png",
  us: "https://cdn3.iconfinder.com/data/icons/world-flags-5/512/26-United_States_of_America_USA_american_americans_united_states_state_US_country_flag_-512.png",
  eg: "http://icons.iconarchive.com/icons/custom-icon-design/all-country-flag/256/Egypt-Flag-icon.png",
  se: "https://icons.iconarchive.com/icons/wikipedia/flags/64/SE-Sweden-Flag-icon.png",
  ae:"https://icons.iconarchive.com/icons/custom-icon-design/all-country-flag/96/Jordan-Flag-icon.png"
};
const techIcons = {
  js: "https://img.icons8.com/material-rounded/96/000000/js.png",
  node: "https://img.icons8.com/windows/96/000000/nodejs.png",
  react: "https://img.icons8.com/ios-glyphs/90/000000/react.png",
  mysql: "https://img.icons8.com/material-rounded/96/000000/mysql.png",
  graphql: "https://img.icons8.com/color/48/000000/graphql.png",
  mongo: "https://img.icons8.com/color/96/000000/mongodb.png",
  php: "https://img.icons8.com/ios-glyphs/96/000000/php.png",
};
// const phrases = ["An array", "of strings", "to pass the component"]; // Required
// const interval = 3000; // The time to wait before rendering the next string
// const typistProps = {} // Props that are passed to the react-typist component
// const loopPhrases = true // Set to false to stop at last phrase

export default class Animation extends React.Component {
  render() {
    return (
      // d tmam mazbota betetba3 el image
      // {projects.map(function(item, i){
      //   console.log('test');
      //   return (
      //     <Parallax.Layer
      //       offset={i}
      //       speed={0.1}
      //       onClick={() => this.parallax.scrollTo(1)}
      //       style={{ display: 'flex', alignItems: 'right', justifyContent: 'right' }}>
      //
      //       <img src={item.image} style={{width:'60%',height:'70%',marginLeft:'40%',marginTop:'7%'}} />
      //
      //       </Parallax.Layer>
      //     )
      // })}
      <div class="grid-container">
        <Helmet>
          <meta name="viewport" content="width=2000" />
          <title>FFawzy Portfolio</title>
        </Helmet>
        <div class="item1">
          <Typing >
            <h1 style={homeT}>Fady Fawzy's Portfolio</h1>
            <span style={desc}>
              Scroll &amp; Click on a project below to view details{" "}
            </span>
          </Typing>
        </div>
        <div class="item2" style={pStyle}>
          <List component="nav">
            {projects.map((item, i) => {
              if (item.active) {
                return (
                  <ListItem
                    className={tes}
                    button
                    onClick={() => this.parallax.scrollTo(i)}
                  >
                    <ListItemIcon>
                      <img
                        src={flags[item.country]}
                        alt="flag-icon"
                        style={{ maxWidth: "40px", marginRight: "0" }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={item.name} />
                  </ListItem>
                );
              } else {
                return "";
              }
            })}
          </List>
        </div>
        <div class="item3" style={{zIndex:'-1'}}>
          <Parallax
            ref={(ref) => (this.parallax = ref)}
            pages={projects.length}
            scrolling={false}
          >
            {projects.map((item, i) => {
              if (item.active) {
                return (
                  <Parallax.Layer
                    offset={i}
                    speed={0.1}
                    style={{
                      display: "flex",
                      alignItems: "right",
                      justifyContent: "right",
                    }}
                  >
                    <h4
                      style={{
                        "max-width": "32%",
                        "margin-left": "10%",
                        "margin-top": "25%",
                        "line-height": "30px",
                      }}
                    >
                      {item.description}
                      <br /> <br /> <br />
                      {item.tech.map((tec) => {
                        return (
                          <img
                            alt="techIcons"
                            src={techIcons[tec]}
                            style={{ width: "40px", margin: "2%" }}
                          />
                        );
                      })}
                    </h4>
                    
                    <div
                      className="slide-container"
                      style={{
                        width: "57%",
                        marginTop: "7%",
                        marginLeft: "1%",
                      }}
                    >
                      <Slide
                        duration="3000"
                        indicators={true}
                        pauseOnHover={true}
                      >
                        {item.images.map((image) => {
                          return (
                            <div className="each-slide">
                              <img
                                src={image}
                                alt={item.name}
                                style={{
                                  borderRadius: "10px",
                                  width: "100%",
                                  height: "100%",
                                  "object-fit": "contain",
                                }}
                              />
                            </div>
                          );
                        })}
                      </Slide>
                    </div>
                    {/* <div style={{}}>
                  <img src={item.image} alt={item.name} style={{width:'100%',height:'100%','object-fit': 'contain'}} />
                </div> */}
                  </Parallax.Layer>
                );
              } else {
                return "";
              }
            })}
          </Parallax>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Animation.js